import { PlugConnected24Regular } from '@/components/Icon'
import { Box, IconButton } from '@mui/material'
import Tooltip from '@/components/Tooltip'
import { useDesignMode } from '@/features/designMode/designModeStore'
import AiAskBarAttachAction from './AiAskBarAttachAction'
import AiAskBarHomeAgentFloatingSelect from './AiAskBarHomeAgentFloatingSelect'
import { MAX_MESSAGE_ATTACHMENTS } from './aiAskBarLayoutConstants'
import styles from './index.module.scss'

export default function AiAskBarLeftActions({
  showAttach,
  showConnections,
  showAgentSelect = false,
  agentSelectValue,
  onAgentSelectChange,
  attachments,
  handleOpenFilePicker,
  onSelectFromDocuments,
  connectionsButtonRef,
  setConnectionsOpen,
  extraActions = [],
}) {
  const designMode = useDesignMode()

  return (
    <Box className={styles.leftActions}>
      {showAttach ? (
        <AiAskBarAttachAction
          disabled={attachments.length >= MAX_MESSAGE_ATTACHMENTS}
          onUpload={handleOpenFilePicker}
          onSelectFromDocuments={onSelectFromDocuments}
        />
      ) : null}
      {showConnections ? (
        <Tooltip text="open connections" placement="bottom">
          <IconButton
            ref={connectionsButtonRef}
            type="button"
            className={styles.circleAction}
            aria-label="Open Connections"
            onClick={() => setConnectionsOpen(true)}
          >
            <PlugConnected24Regular className={styles.circleIcon} aria-hidden />
          </IconButton>
        </Tooltip>
      ) : null}
      {extraActions.map(({ id, label, Icon }) => (
        <Tooltip key={id} text={label.toLowerCase()} placement="bottom">
          <IconButton
            type="button"
            className={styles.circleAction}
            aria-label={label}
            onClick={() => {}}
          >
            <Icon className={styles.circleIcon} aria-hidden />
          </IconButton>
        </Tooltip>
      ))}
      {showAgentSelect && !designMode ? (
        <AiAskBarHomeAgentFloatingSelect value={agentSelectValue} onChange={onAgentSelectChange} />
      ) : null}
    </Box>
  )
}
